export default __webpack_public_path__ + "static/media/information--hospital--g1.df445bc6.png";